import { render, staticRenderFns } from "./EditTrip.vue?vue&type=template&id=5d707f99&scoped=true"
import script from "./EditTrip.vue?vue&type=script&lang=js"
export * from "./EditTrip.vue?vue&type=script&lang=js"
import style0 from "./EditTrip.vue?vue&type=style&index=0&id=5d707f99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d707f99",
  null
  
)

export default component.exports